/* tslint:disable */
/* eslint-disable */
/**
 * Generated API Client Index
 * 
 * This barrel file provides a clean module structure for the NSwag-generated API clients.
 * The original generated.ts file has been split into:
 * - base.ts: Axios utilities and error handling
 * - types.ts: All DTOs, interfaces, and type aliases
 * - requests.ts: Request DTOs for API methods
 * - clients/: Individual client files for each API client
 * - clients/mocked/: Mocked client implementations for UI development
 * - interfaces/: Interface definitions for all clients
 */

// Re-export base utilities
export {
    InventoryApiException,
    throwException,
    isAxiosError,
    axios,
} from './base';

// Re-export types from base
export type {
    AxiosInstance,
    AxiosRequestConfig,
    AxiosResponse,
    CancelToken,
    FileParameter,
    FileResponse,
    ProblemDetails,
} from './base';

// Re-export all types (includes re-exports from requests.ts)
export * from './types';

// Re-export all clients from individual files
export * from './clients';

// Re-export all client interfaces
export * from './interfaces';

// Re-export mocked clients
export * from './clients/mocked';

// ============================================================================
// Factory Functions - Main Decision Point for Real vs Mocked Clients
// ============================================================================

import { shouldUseMockedClient } from '../../environment';
import { AxiosInstance } from 'axios';

// Import real clients
import { AutomatedTasksClient } from './clients/AutomatedTasksClient';
import { BrandingsClient } from './clients/BrandingsClient';
import { ConfigurationsClient } from './clients/ConfigurationsClient';
import { ConversionsClient } from './clients/ConversionsClient';
import { DashboardClient } from './clients/DashboardClient';
import { DistrictsClient } from './clients/DistrictsClient';
import { InternalClient } from './clients/InternalClient';
import { InvoiceClient } from './clients/InvoiceClient';
import { ItemAndComponentClient } from './clients/ItemAndComponentClient';
import { ItemCostHistoriesClient } from './clients/ItemCostHistoriesClient';
import { ItemHistoryClient } from './clients/ItemHistoryClient';
import { ItemsClient } from './clients/ItemsClient';
import { LocationsClient } from './clients/LocationsClient';
import { MadeInStoreClient } from './clients/MadeInStoreClient';
import { MaterialsClient } from './clients/MaterialsClient';
import { NotificationsClient } from './clients/NotificationsClient';
import { PersonasClient } from './clients/PersonasClient';
import { PredictiveOrderingClient } from './clients/PredictiveOrderingClient';
import { PrimaryCategoryClient } from './clients/PrimaryCategoryClient';
import { PurchaseOrdersClient } from './clients/PurchaseOrdersClient';
import { ReportsClient } from './clients/ReportsClient';
import { RolesClient } from './clients/RolesClient';
import { SalesForecastingClient } from './clients/SalesForecastingClient';
import { SourceTransactionsClient } from './clients/SourceTransactionsClient';
import { StockCheckClient } from './clients/StockCheckClient';
import { StockCheckScheduleClient } from './clients/StockCheckScheduleClient';
import { StockCheckUomsClient } from './clients/StockCheckUomsClient';
import { StockClient } from './clients/StockClient';
import { StoresClient } from './clients/StoresClient';
import { TasksClient } from './clients/TasksClient';
import { TimezonesClient } from './clients/TimezonesClient';
import { TransactionReasonsClient } from './clients/TransactionReasonsClient';
import { TransactionsClient } from './clients/TransactionsClient';
import { TransactionTypesClient } from './clients/TransactionTypesClient';
import { TransfersClient } from './clients/TransfersClient';
import { UsersClient } from './clients/UsersClient';
import { WasteClient } from './clients/WasteClient';

// Import mocked clients
import { AutomatedTasksClientMocked } from './clients/mocked/AutomatedTasksClientMocked';
import { BrandingsClientMocked } from './clients/mocked/BrandingsClientMocked';
import { ConfigurationsClientMocked } from './clients/mocked/ConfigurationsClientMocked';
import { ConversionsClientMocked } from './clients/mocked/ConversionsClientMocked';
import { DashboardClientMocked } from './clients/mocked/DashboardClientMocked';
import { DistrictsClientMocked } from './clients/mocked/DistrictsClientMocked';
import { InternalClientMocked } from './clients/mocked/InternalClientMocked';
import { InvoiceClientMocked } from './clients/mocked/InvoiceClientMocked';
import { ItemAndComponentClientMocked } from './clients/mocked/ItemAndComponentClientMocked';
import { ItemCostHistoriesClientMocked } from './clients/mocked/ItemCostHistoriesClientMocked';
import { ItemHistoryClientMocked } from './clients/mocked/ItemHistoryClientMocked';
import { ItemsClientMocked } from './clients/mocked/ItemsClientMocked';
import { LocationsClientMocked } from './clients/mocked/LocationsClientMocked';
import { MadeInStoreClientMocked } from './clients/mocked/MadeInStoreClientMocked';
import { MaterialsClientMocked } from './clients/mocked/MaterialsClientMocked';
import { NotificationsClientMocked } from './clients/mocked/NotificationsClientMocked';
import { PersonasClientMocked } from './clients/mocked/PersonasClientMocked';
import { PredictiveOrderingClientMocked } from './clients/mocked/PredictiveOrderingClientMocked';
import { PrimaryCategoryClientMocked } from './clients/mocked/PrimaryCategoryClientMocked';
import { PurchaseOrdersClientMocked } from './clients/mocked/PurchaseOrdersClientMocked';
import { ReportsClientMocked } from './clients/mocked/ReportsClientMocked';
import { RolesClientMocked } from './clients/mocked/RolesClientMocked';
import { SalesForecastingClientMocked } from './clients/mocked/SalesForecastingClientMocked';
import { SourceTransactionsClientMocked } from './clients/mocked/SourceTransactionsClientMocked';
import { StockCheckClientMocked } from './clients/mocked/StockCheckClientMocked';
import { StockCheckScheduleClientMocked } from './clients/mocked/StockCheckScheduleClientMocked';
import { StockCheckUomsClientMocked } from './clients/mocked/StockCheckUomsClientMocked';
import { StockClientMocked } from './clients/mocked/StockClientMocked';
import { StoresClientMocked } from './clients/mocked/StoresClientMocked';
import { TasksClientMocked } from './clients/mocked/TasksClientMocked';
import { TimezonesClientMocked } from './clients/mocked/TimezonesClientMocked';
import { TransactionReasonsClientMocked } from './clients/mocked/TransactionReasonsClientMocked';
import { TransactionsClientMocked } from './clients/mocked/TransactionsClientMocked';
import { TransactionTypesClientMocked } from './clients/mocked/TransactionTypesClientMocked';
import { TransfersClientMocked } from './clients/mocked/TransfersClientMocked';
import { UsersClientMocked } from './clients/mocked/UsersClientMocked';
import { WasteClientMocked } from './clients/mocked/WasteClientMocked';

// Import interfaces
import type {
    IAutomatedTasksClient,
    IBrandingsClient,
    IConfigurationsClient,
    IConversionsClient,
    IDashboardClient,
    IDistrictsClient,
    IInternalClient,
    IInvoiceClient,
    IItemAndComponentClient,
    IItemCostHistoriesClient,
    IItemHistoryClient,
    IItemsClient,
    ILocationsClient,
    IMadeInStoreClient,
    IMaterialsClient,
    INotificationsClient,
    IPersonasClient,
    IPredictiveOrderingClient,
    IPrimaryCategoryClient,
    IPurchaseOrdersClient,
    IReportsClient,
    IRolesClient,
    ISalesForecastingClient,
    ISourceTransactionsClient,
    IStockCheckClient,
    IStockCheckScheduleClient,
    IStockCheckUomsClient,
    IStockClient,
    IStoresClient,
    ITasksClient,
    ITimezonesClient,
    ITransactionReasonsClient,
    ITransactionsClient,
    ITransactionTypesClient,
    ITransfersClient,
    IUsersClient,
    IWasteClient,
} from './interfaces';

/**
 * Determines whether to use mocked clients.
 * Automatically uses mocked clients on localhost and ofstest5 environments.
 * @deprecated Use shouldUseMockedClient() from environment.ts directly
 */
export const USE_REAL_API = !shouldUseMockedClient();

/**
 * Factory functions that return the appropriate client implementation.
 * These functions return interface types, ensuring both real and mocked clients
 * are interchangeable. The decision to use real vs mocked is made here at the top level.
 * 
 * Note: Mocked clients implement a subset of the interface for UI development.
 * Type assertions are used since mocked clients may not implement all methods.
 */

export const getAutomatedTasksClient = (baseUrl?: string, axiosInstance?: AxiosInstance): IAutomatedTasksClient =>
  shouldUseMockedClient() ? new AutomatedTasksClientMocked(baseUrl) as unknown as IAutomatedTasksClient : new AutomatedTasksClient(baseUrl, axiosInstance);

export const getBrandingsClient = (baseUrl?: string, axiosInstance?: AxiosInstance): IBrandingsClient =>
  shouldUseMockedClient() ? new BrandingsClientMocked(baseUrl) : new BrandingsClient(baseUrl, axiosInstance);

export const getConfigurationsClient = (baseUrl?: string, axiosInstance?: AxiosInstance): IConfigurationsClient =>
  shouldUseMockedClient() ? new ConfigurationsClientMocked(baseUrl) : new ConfigurationsClient(baseUrl, axiosInstance);

export const getConversionsClient = (baseUrl?: string, axiosInstance?: AxiosInstance): IConversionsClient =>
  shouldUseMockedClient() ? new ConversionsClientMocked(baseUrl) : new ConversionsClient(baseUrl, axiosInstance);

export const getDashboardClient = (baseUrl?: string, axiosInstance?: AxiosInstance): IDashboardClient =>
  shouldUseMockedClient() ? new DashboardClientMocked(baseUrl) : new DashboardClient(baseUrl, axiosInstance);

export const getDistrictsClient = (baseUrl?: string, axiosInstance?: AxiosInstance): IDistrictsClient =>
  shouldUseMockedClient() ? new DistrictsClientMocked(baseUrl) : new DistrictsClient(baseUrl, axiosInstance);

export const getInternalClient = (baseUrl?: string, axiosInstance?: AxiosInstance): IInternalClient =>
  shouldUseMockedClient() ? new InternalClientMocked(baseUrl) : new InternalClient(baseUrl, axiosInstance);

export const getInvoiceClient = (baseUrl?: string, axiosInstance?: AxiosInstance): IInvoiceClient =>
  shouldUseMockedClient() ? new InvoiceClientMocked(baseUrl) : new InvoiceClient(baseUrl, axiosInstance);

export const getItemAndComponentClient = (baseUrl?: string, axiosInstance?: AxiosInstance): IItemAndComponentClient =>
  shouldUseMockedClient() ? new ItemAndComponentClientMocked(baseUrl) : new ItemAndComponentClient(baseUrl, axiosInstance);

export const getItemCostHistoriesClient = (baseUrl?: string, axiosInstance?: AxiosInstance): IItemCostHistoriesClient =>
  shouldUseMockedClient() ? new ItemCostHistoriesClientMocked(baseUrl) : new ItemCostHistoriesClient(baseUrl, axiosInstance);

export const getItemHistoryClient = (baseUrl?: string, axiosInstance?: AxiosInstance): IItemHistoryClient =>
  shouldUseMockedClient() ? new ItemHistoryClientMocked(baseUrl) : new ItemHistoryClient(baseUrl, axiosInstance);

export const getItemsClient = (baseUrl?: string, axiosInstance?: AxiosInstance): IItemsClient =>
  shouldUseMockedClient() ? new ItemsClientMocked(baseUrl) : new ItemsClient(baseUrl, axiosInstance);

export const getLocationsClient = (baseUrl?: string, axiosInstance?: AxiosInstance): ILocationsClient =>
  shouldUseMockedClient() ? new LocationsClientMocked(baseUrl) : new LocationsClient(baseUrl, axiosInstance);

export const getMadeInStoreClient = (baseUrl?: string, axiosInstance?: AxiosInstance): IMadeInStoreClient =>
  shouldUseMockedClient() ? new MadeInStoreClientMocked(baseUrl) : new MadeInStoreClient(baseUrl, axiosInstance);

export const getMaterialsClient = (baseUrl?: string, axiosInstance?: AxiosInstance): IMaterialsClient =>
  shouldUseMockedClient() ? new MaterialsClientMocked(baseUrl) : new MaterialsClient(baseUrl, axiosInstance);

export const getNotificationsClient = (baseUrl?: string, axiosInstance?: AxiosInstance): INotificationsClient =>
  shouldUseMockedClient() ? new NotificationsClientMocked(baseUrl) : new NotificationsClient(baseUrl, axiosInstance);

export const getPersonasClient = (baseUrl?: string, axiosInstance?: AxiosInstance): IPersonasClient =>
  shouldUseMockedClient() ? new PersonasClientMocked(baseUrl) : new PersonasClient(baseUrl, axiosInstance);

export const getPredictiveOrderingClient = (baseUrl?: string, axiosInstance?: AxiosInstance): IPredictiveOrderingClient =>
  shouldUseMockedClient() ? new PredictiveOrderingClientMocked(baseUrl) : new PredictiveOrderingClient(baseUrl, axiosInstance);

export const getPrimaryCategoryClient = (baseUrl?: string, axiosInstance?: AxiosInstance): IPrimaryCategoryClient =>
  shouldUseMockedClient() ? new PrimaryCategoryClientMocked(baseUrl) : new PrimaryCategoryClient(baseUrl, axiosInstance);

export const getPurchaseOrdersClient = (baseUrl?: string, axiosInstance?: AxiosInstance): IPurchaseOrdersClient =>
  shouldUseMockedClient() ? new PurchaseOrdersClientMocked(baseUrl) : new PurchaseOrdersClient(baseUrl, axiosInstance);

export const getReportsClient = (baseUrl?: string, axiosInstance?: AxiosInstance): IReportsClient =>
  shouldUseMockedClient() ? new ReportsClientMocked(baseUrl) : new ReportsClient(baseUrl, axiosInstance);

export const getRolesClient = (baseUrl?: string, axiosInstance?: AxiosInstance): IRolesClient =>
  shouldUseMockedClient() ? new RolesClientMocked(baseUrl) : new RolesClient(baseUrl, axiosInstance);

export const getSalesForecastingClient = (baseUrl?: string, axiosInstance?: AxiosInstance): ISalesForecastingClient =>
  shouldUseMockedClient() ? new SalesForecastingClientMocked(baseUrl) : new SalesForecastingClient(baseUrl, axiosInstance);

export const getSourceTransactionsClient = (baseUrl?: string, axiosInstance?: AxiosInstance): ISourceTransactionsClient =>
  shouldUseMockedClient() ? new SourceTransactionsClientMocked(baseUrl) : new SourceTransactionsClient(baseUrl, axiosInstance);

export const getStockCheckClient = (baseUrl?: string, axiosInstance?: AxiosInstance): IStockCheckClient =>
  shouldUseMockedClient() ? new StockCheckClientMocked(baseUrl) : new StockCheckClient(baseUrl, axiosInstance);

export const getStockCheckScheduleClient = (baseUrl?: string, axiosInstance?: AxiosInstance): IStockCheckScheduleClient =>
  shouldUseMockedClient() ? new StockCheckScheduleClientMocked(baseUrl) : new StockCheckScheduleClient(baseUrl, axiosInstance);

export const getStockCheckUomsClient = (baseUrl?: string, axiosInstance?: AxiosInstance): IStockCheckUomsClient =>
  shouldUseMockedClient() ? new StockCheckUomsClientMocked(baseUrl) : new StockCheckUomsClient(baseUrl, axiosInstance);

export const getStockClient = (baseUrl?: string, axiosInstance?: AxiosInstance): IStockClient =>
  shouldUseMockedClient() ? new StockClientMocked(baseUrl) : new StockClient(baseUrl, axiosInstance);

export const getStoresClient = (baseUrl?: string, axiosInstance?: AxiosInstance): IStoresClient =>
  shouldUseMockedClient() ? new StoresClientMocked(baseUrl) : new StoresClient(baseUrl, axiosInstance);

export const getTasksClient = (baseUrl?: string, axiosInstance?: AxiosInstance): ITasksClient =>
  shouldUseMockedClient() ? new TasksClientMocked(baseUrl) : new TasksClient(baseUrl, axiosInstance);

export const getTimezonesClient = (baseUrl?: string, axiosInstance?: AxiosInstance): ITimezonesClient =>
  shouldUseMockedClient() ? new TimezonesClientMocked(baseUrl) : new TimezonesClient(baseUrl, axiosInstance);

export const getTransactionReasonsClient = (baseUrl?: string, axiosInstance?: AxiosInstance): ITransactionReasonsClient =>
  shouldUseMockedClient() ? new TransactionReasonsClientMocked(baseUrl) : new TransactionReasonsClient(baseUrl, axiosInstance);

export const getTransactionsClient = (baseUrl?: string, axiosInstance?: AxiosInstance): ITransactionsClient =>
  shouldUseMockedClient() ? new TransactionsClientMocked(baseUrl) : new TransactionsClient(baseUrl, axiosInstance);

export const getTransactionTypesClient = (baseUrl?: string, axiosInstance?: AxiosInstance): ITransactionTypesClient =>
  shouldUseMockedClient() ? new TransactionTypesClientMocked(baseUrl) : new TransactionTypesClient(baseUrl, axiosInstance);

export const getTransfersClient = (baseUrl?: string, axiosInstance?: AxiosInstance): ITransfersClient =>
  shouldUseMockedClient() ? new TransfersClientMocked(baseUrl) : new TransfersClient(baseUrl, axiosInstance);

export const getUsersClient = (baseUrl?: string, axiosInstance?: AxiosInstance): IUsersClient =>
  shouldUseMockedClient() ? new UsersClientMocked(baseUrl) : new UsersClient(baseUrl, axiosInstance);

export const getWasteClient = (baseUrl?: string, axiosInstance?: AxiosInstance): IWasteClient =>
  shouldUseMockedClient() ? new WasteClientMocked(baseUrl) : new WasteClient(baseUrl, axiosInstance);
